import React from 'react';
import ProductsSearchResult from '@components/ProductsSearchResult';
import { EmptyObject } from '@monofront/types';

type SearchProps = EmptyObject;

const Search: React.FC<SearchProps> = () => {
  return (
    <>
      <section className="limited-width-container">
        <ProductsSearchResult hasCollectionsCarouselTags />
        <style jsx>{`
          section {
            margin-top: var(--space-4);
            margin-bottom: var(--space-6);
          }

          section :global(.hero-collection-container) {
            margin-bottom: var(--space-5);
          }

          @media (max-width: 800px) {
            section {
              margin-top: 0;
              margin-bottom: 0;
              padding: 0;
            }
          }
        `}</style>
      </section>
    </>
  );
};

export default Search;
